//!!!!! TODO: Do not mutate state directly fix it asap!!!!!!
import React from 'react'
import Reflux from 'reflux'
import Store from '../../store/store'
import Upload from './steps/upload'
import HeaderSteps from './headersteps'
import Download from './steps/download'
import BaseComponent from '../base'
import api from "../../source/api";

class Cashregister extends BaseComponent {

    constructor(props) {
        super(props)
        this.state = {
            hidemenu: false,
            files: [],
            totalSummarization: [],
            summarization: [],
            userconfigs: {},
            steps: {
                next: 2,
                current: 1,
                data: {}
            },
            company_id: props.location.match.params.id,
            company: null
        }
        this.store = Store
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use componentDidMount instead.
     */
    componentWillMount = () => {
        api.get({url: 'cashregister/init?company_id=' + this.state.company_id}, true).then((response) => {
            this.setState({
                userconfigs: response.data.userconfigs || {},
                company: response.data.company,
            })
        })
    }

    hideStepsMenu = () => {
        this.setState({hidemenu: true})
    }

    setNextStep = () => {
        let steps = this.state.steps;
        steps.current += 1
        steps.next = steps.current + 1
        this.setState({steps: steps});
    }

    componentDidMount = () => {
        window.scrollTo(0, 0)
    }

    prevStep = (step) => {
        let steps = this.state.steps;
        steps.current = 1;
        steps.next = 2;
        this.setState({steps: steps});
    }

    setOutputFiles = (data) => {
        this.setState({
            files: data.file,
            totalSummarization: data.totalSummarization,
            summarization: data.summarization,
        })
    }

    render() {
        return (
            <section id='cashregister-upload'>
                {!this.state.hidemenu ? <HeaderSteps prevStep={(step) => this.prevStep(step)} currentStep={this.state.steps.current}/> : null}
                <div className='header'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-10 offset-1'>
                                <h1 className='text-center'>
                                    Pénztárgépszalagok automatikus könyvelése
                                </h1>

                                <div className={this.state.steps.current == 1 ? 'col-12' : 'd-none'}>
                                    <p>
                                        Töltse fel a könyvelt cégtől kapott pénztárszalag XML-eket, ZIP-ben. Válassza ki az Ön által használt könyvelőprogramot, amennyiben először használja az adott modult, kérjük, paraméterezze fel az adott cég Főkönyvi struktúráját.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='upload-body'>
                    <div className='container'>
                        <div className={this.state.steps.current == 1 ? 'row' : 'd-none'}>
                            <Upload
                                {...this.props}
                                company={this.state.company}
                                userconfigs={this.state.userconfigs}
                                setOutputFiles={(files) => this.setOutputFiles(files)}
                                setNextStep={() => this.setNextStep()}
                                setValue={(name, value, error) => this.setValue(name, value, error)}/>
                        </div>
                        <div className={this.state.steps.current == 2 ? 'row' : 'd-none'}>
                            <Download
                                files={this.state.files}
                                hideStepsMenu={() => this.hideStepsMenu()}
                                summarization={this.state.summarization}
                                totalSummarization={this.state.totalSummarization}
                                {...this.props} />
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default Cashregister


// WEBPACK FOOTER //
// ./src/components/cashregister/cashregister.js